// helpers/isMetrikaEmbedding.js
export function isMetrikaEmbedding() {
    const RE =
        /(^https?:\/\/)?([^/]+\.)?(webvisor\.com|mc\.yandex\.(ru|com)|metri[ck]a\.yandex\.(ru|com|by|com\.tr)|yandex\.(ru|com|by|com\.tr))/i
    try {
        const ao = window.location.ancestorOrigins
        if (ao && ao.length) return Array.from(ao).some(o => RE.test(String(o)))
    } catch {}
    const ref = document.referrer || ''
    const inFrame = window.self !== window.top
    return RE.test(ref) || (inFrame && /yandex|webvisor/i.test(ref))
}
